import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout.js';
import { ProtectedRoute } from './components/ProtectedRoute.js';
import { Login } from './pages/Login.js';
import { OrderDetail } from './pages/OrderDetail.js';
import { Orders } from './pages/Orders.js';
import { ProductDetail } from './pages/ProductDetail.js';
import { Products } from './pages/Products.js';

export function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/orders"
          element={
            <ProtectedRoute roles={['Admin', 'Sales', 'Viewer']}>
              <Orders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders/:reference"
          element={
            <ProtectedRoute roles={['Admin', 'Sales', 'Viewer']}>
              <OrderDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/products"
          element={
            <ProtectedRoute roles={['Admin', 'Sales', 'Viewer']}>
              <Products />
            </ProtectedRoute>
          }
        />
        <Route
          path="/products/:region/:inventoryID"
          element={
            <ProtectedRoute roles={['Admin', 'Sales', 'Viewer']}>
              <ProductDetail />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/orders" replace />} />
      </Routes>
    </Layout>
  );
}
